import { render, staticRenderFns } from "./EditorComponent.vue?vue&type=template&id=2f4676c6&"
import script from "./EditorComponent.vue?vue&type=script&lang=js&"
export * from "./EditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditorComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports